import React from "react";
import { motion } from "framer-motion";
import Header from "../components/Header";

export default function AboutUsPage() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <Header />
      <main className="flex-1 flex flex-col">
        <section className="w-full bg-gray-100 py-16 px-4 sm:px-6 lg:px-16 relative overflow-hidden min-h-[calc(100vh-80px)]">
          {/* Subtle background pattern */}
          <div className="absolute inset-0 opacity-[0.03] pointer-events-none">
            <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(#000 1px, transparent 1px)', backgroundSize: '40px 40px' }}></div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center max-w-7xl mx-auto py-4 lg:py-8">
            {/* Left Column: Text Content */}
            <div className="text-left relative overflow-visible lg:pr-8">
              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black text-black leading-none"
              >
                AB<span className="inline-block relative px-1">
                  <span className="relative z-10">O</span>
                  <span className="absolute inset-0 bg-yellow-400 rounded-full transform scale-105 -z-0"></span>
                </span>UT
                <br />
                US!
              </motion.h1>
              
              <div className="relative" style={{ height: '6px', marginTop: '32px', marginBottom: '32px' }}>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ delay: 0.3, duration: 0.7 }}
                  className="bg-black absolute"
                  style={{ height: '6px', width: '100%', left: 0 }}
                ></motion.div>
              </div>
              
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5, duration: 0.7 }}
                className="mt-6 text-black space-y-4 max-w-2xl"
              >
                <p className="text-sm leading-relaxed">
                  Welcome to Job Loop, the next-generation job portal designed to transform your hiring experience. Job Loop combines smart technology with powerful AI to make recruitment faster, easier, and more effective for every business.
                </p>
                <p className="text-sm leading-relaxed">
                  Our platform offers advanced AI features that take the guesswork out of hiring. With AI-powered candidate search and intelligent resume screening, you can instantly discover applicants who best fit your job requirements—each profile scored and highlighted so you can focus on quality matches. Automated pipelines, helpful analytics, and effortless interview scheduling let you manage candidates with confidence and speed.
                </p>
                <p className="text-sm leading-relaxed">
                  Job Loop's AI-driven tools save recruiters countless hours, reduce manual workload, and help employers make smarter hiring choices every step of the way. Discover a modern way to recruit—where finding the right candidate is easy, efficient, and always within reach.
                </p>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.7, duration: 0.7 }}
                className="mt-8"
              >
                <a 
                  href="/contact" 
                  className="font-bold bg-black text-white px-8 py-3 border-2 border-black hover:bg-gray-900 transition-colors inline-block"
                >
                  CONTACT US
                </a>
              </motion.div>
            </div>

            {/* Right Column: Hero Image */}
            <div className="relative lg:pl-8">
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.7 }}
                className="w-full h-full relative"
              >
                <div className="absolute -top-4 -left-4 w-24 h-24 bg-yellow-400 rounded-full opacity-20"></div>
                <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-yellow-400 rounded-full opacity-20"></div>
                <img 
                  src="/images/hero-image-3.png" 
                  alt="Job Loop Platform" 
                  className="w-full h-auto rounded-lg shadow-lg relative z-10"
                />
              </motion.div>
              
              {/* Yellow Dots - Bottom Right */}
              <div className="absolute bottom-0 right-0 flex space-x-2">
                <div className="w-2 h-2 rounded-full bg-yellow-400"></div>
                <div className="w-2 h-2 rounded-full bg-yellow-400"></div>
                <div className="w-2 h-2 rounded-full bg-yellow-400"></div>
                <div className="w-2 h-2 rounded-full bg-yellow-400"></div>
              </div>
            </div>
          </div>
        </section>

        {/* No additional sections - removed Values and Team sections */}
      </main>
    </div>
  );
}
